import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import AgeGroup from './model';

export const fetchAgeGroups = institutionId => {
    return RESTClient.getAuthenticatedObservable('v2/agegroups', {institutionId}).map(data => ({
        behaviors: new BehaviorsCollection(data.behaviors),
        ageGroups: List(data.ageGroups.map(AgeGroup.fromAPI)),
    }));
};

export const createAgeGroups = (institutionId, ageGroups) => {
    return RESTClient.postAuthenticatedObservable(`v2/agegroups?institutionId=${institutionId}`, {
        ageGroups,
    }).map(data => List(data.ageGroups).map(AgeGroup.fromAPI));
};

export const updateAgeGroups = (institutionId, ageGroups) => {
    return RESTClient.putAuthenticatedObservable(`v2/agegroups?institutionId=${institutionId}`, {ageGroups}).map(data =>
        List(data.ageGroups).map(AgeGroup.fromAPI),
    );
};
